<template>
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
  >
    <path d="M2 3C2 2.44772 2.44772 2 3 2H9C9.55228 2 10 2.44772 10 3V4C10 4.55228 9.55228 5 9 5H3C2.44772 5 2 4.55228 2 4V3ZM3 3V4H9V3H3ZM0 2V14C0 15.1046 0.89543 16 2 16H11.5C11.7761 16 12 15.7761 12 15.5C12 15.2239 11.7761 15 11.5 15H2C1.44772 15 1 14.5523 1 14H11C11.5523 14 12 13.5523 12 13V2C12 0.895431 11.1046 0 10 0H2C0.895431 0 0 0.89543 0 2ZM10 1C10.5523 1 11 1.44772 11 2V13H1V2C1 1.44772 1.44772 1 2 1H10Z" />
  </svg>
</template>